const Theme = {
  logo_image_url: 'tourismetemis.jpg',
  logo_height: 140,

  body_background_color: '#739692',

  token_hidden: true,
  title_font: `'Graebenbach-Regular', sans-serif`,
  subtitle_font: `'Graebenbach-Regular', sans-serif`,

  button_color: '#f3f44d',
  button_radius: 50,
  button_border_width: 1,
}

export default Theme
